/** Umschalttag Billbee → StoreOS (N2/R71): Vorschau (Leitung), Durchführen (Admin), Bestätigung je Auftrag (Leitung). */
import type { Json, UmschaltBestaetigung, UmschaltEntscheidung, UmschaltErgebnis, UmschaltPlan } from '@storeos/contracts';
import { api, post } from '../api';

export type UmschaltPlanJson = Json<UmschaltPlan>;
export type UmschaltErgebnisJson = Json<UmschaltErgebnis>;

export const umschaltVorschau = (t0: string) => api<UmschaltPlanJson>(`/umschaltung?t0=${encodeURIComponent(t0)}`);
/** Admin: unumkehrbar für die Archiv-Aufträge (Sendungen storniert, keine Rechnung). */
export const umschaltDurchfuehren = (t0: string) => post<UmschaltErgebnisJson>('/umschaltung/durchfuehren', { t0 });
/** Leitung: Übernahme bestätigen (StoreOS) oder an Billbee geben (Archiv). Grund Pflicht in der SPA. */
export const umschaltBestaetigen = (orderIds: string[], entscheidung: UmschaltEntscheidung, grund: string) =>
  post<UmschaltBestaetigung>('/umschaltung/bestaetigen', { order_ids: orderIds, entscheidung, grund });
